/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecommendCodeBindDetailRespVo } from './RecommendCodeBindDetailRespVo';
import {
    RecommendCodeBindDetailRespVoFromJSON,
    RecommendCodeBindDetailRespVoFromJSONTyped,
    RecommendCodeBindDetailRespVoToJSON,
    RecommendCodeBindDetailRespVoToJSONTyped,
} from './RecommendCodeBindDetailRespVo';

/**
 * 
 * @export
 * @interface ResponseRecommendCodeBindDetailRespVo
 */
export interface ResponseRecommendCodeBindDetailRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseRecommendCodeBindDetailRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseRecommendCodeBindDetailRespVo
     */
    message?: string;
    /**
     * 
     * @type {RecommendCodeBindDetailRespVo}
     * @memberof ResponseRecommendCodeBindDetailRespVo
     */
    data?: RecommendCodeBindDetailRespVo;
}

/**
 * Check if a given object implements the ResponseRecommendCodeBindDetailRespVo interface.
 */
export function instanceOfResponseRecommendCodeBindDetailRespVo(value: object): value is ResponseRecommendCodeBindDetailRespVo {
    return true;
}

export function ResponseRecommendCodeBindDetailRespVoFromJSON(json: any): ResponseRecommendCodeBindDetailRespVo {
    return ResponseRecommendCodeBindDetailRespVoFromJSONTyped(json, false);
}

export function ResponseRecommendCodeBindDetailRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseRecommendCodeBindDetailRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RecommendCodeBindDetailRespVoFromJSON(json['data']),
    };
}

export function ResponseRecommendCodeBindDetailRespVoToJSON(json: any): ResponseRecommendCodeBindDetailRespVo {
    return ResponseRecommendCodeBindDetailRespVoToJSONTyped(json, false);
}

export function ResponseRecommendCodeBindDetailRespVoToJSONTyped(value?: ResponseRecommendCodeBindDetailRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': RecommendCodeBindDetailRespVoToJSON(value['data']),
    };
}

